import { LibraryBrowser } from "@/components/media/library-browser";

interface Props {
  brandId: string;
  /** "IMAGE" | "VIDEO" | "DOCUMENT" — restrict the picker to a single asset type */
  type?: "IMAGE" | "VIDEO" | "DOCUMENT";
  /** Current selection (mediaUrls). The picker maps urls back to assets when possible. */
  selectedUrls: string[];
  /** Multi-select? Defaults to true; pass false for single-asset types like LinkedIn doc. */
  multi?: boolean;
  /** Max items the consumer wants. */
  max?: number;
  onChange: (urls: string[]) => void;
  onClose?: () => void;
}

/** Inline asset picker used by PostTypeEditor. Thin wrapper over the shared
 *  LibraryBrowser (search + tags + pagination); url-based selection contract. */
export function AssetPicker({ brandId, type, selectedUrls, multi = true, max, onChange, onClose }: Props) {
  return (
    <div className="rounded-lg border bg-card p-3">
      <LibraryBrowser
        brandId={brandId}
        type={type ?? null}
        selectable
        multi={multi}
        max={max}
        selectedUrls={selectedUrls}
        onSelectChange={(urls) => onChange(urls)}
      />
      {onClose && (
        <div className="mt-2 flex justify-end">
          <button type="button" onClick={onClose} className="rounded border px-2 py-1 text-xs hover:bg-muted">
            Done
          </button>
        </div>
      )}
    </div>
  );
}
